import { SERVER_AXIOS } from "./config"

export const GET_METHOD = async (apiUrl,header) =>  await SERVER_AXIOS.get(apiUrl,header);

export const DELETE_METHOD = async (apiUrl,header) =>  await SERVER_AXIOS.delete(apiUrl,header);

export const POST_METHOD= async (apiUrl, data, header) => await SERVER_AXIOS.post(apiUrl, data,header);

export const PUT_METHOD= async (apiUrl, data, header) => await SERVER_AXIOS.put(apiUrl, data,header);